import React from 'react';
import { Rocket, Building2, Globe, Calculator } from 'lucide-react';

const cards = [
  {
    icon: Rocket,
    title: 'Startups & Funded Companies',
    desc: 'Preparing for your next funding round? We handle investor reporting, financial projections and due diligence support.',
    color: 'bg-emerald-50 text-emerald-600',
  },
  {
    icon: Building2,
    title: 'SMEs & Family Businesses',
    desc: 'Growing fast but no full-time CFO? We bring financial discipline, MIS dashboards and strategic oversight.',
    color: 'bg-blue-50 text-blue-600',
  },
  {
    icon: Globe,
    title: 'Foreign Companies Entering India',
    desc: 'Setting up in India? We manage compliance, entity structuring, GST registration and ongoing financial reporting.',
    color: 'bg-amber-50 text-amber-600',
  },
  {
    icon: Calculator,
    title: 'Founders Who Hate Numbers',
    desc: 'Focus on building your business. We handle the numbers, deadlines, filings and financial decisions — you just review.',
    color: 'bg-purple-50 text-purple-600',
  },
];

export const WhoWeHelpSection = () => (
  <section id="who-we-help" className="py-16 sm:py-20 px-4 sm:px-6 bg-white">
    <div className="max-w-7xl mx-auto">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-3">Who We Work With</h2>
      <p className="text-gray-600 text-center mb-10 sm:mb-12 max-w-2xl mx-auto">We partner with businesses at every stage — from bootstrapped startups to established enterprises.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((c, i) => (
          <div key={c.title || `card-${i}`} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${c.color}`}>
              <c.icon className="w-6 h-6" />
            </div>
            <h3 className="text-base font-semibold text-gray-900 mb-2">{c.title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed">{c.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
